import { supabase } from "@/utils/supabase";
import { ChargingStationModelMapper } from "@/adapters/ChargingStationModel.mapper";
import { getRootStore } from "@/stores/RootStore";
/**
 * Concrete implementation of ChargingStationModelService
 * Handles all database operations for charging station models
 */
export class ChargingStationModelService {
    async getModelsWithParams(params) {
        try {
            let query = supabase()
                .from("chargingStationModelsSearchView")
                .select("*", { count: "exact" });
            // Фильтры
            if (params.filters) {
                const search = params.filters.search?.trim();
                if (search) {
                    const ors = [
                        `name.ilike.*${search}*`,
                        `manufacturerName.ilike.*${search}*`,
                    ];
                    query = query.or(ors.join(","));
                }
            }
            // Сортировка
            if (params.sorters && Object.keys(params.sorters).length > 0) {
                Object.entries(params.sorters).forEach(([field, order]) => {
                    if (order === "ascend")
                        query = query.order(field, { ascending: true });
                    else if (order === "descend")
                        query = query.order(field, { ascending: false });
                });
            }
            else {
                query = query.order("name", { ascending: true });
            }
            // Пагинация
            const from = (params.page - 1) * params.pageSize;
            query = query.range(from, from + params.pageSize - 1);
            const { data, error, count } = await query;
            if (error)
                throw error;
            return {
                data: data.map(ChargingStationModelMapper.toSearchData),
                total: count || 0,
                page: params.page,
                pageSize: params.pageSize,
            };
        }
        catch (error) {
            console.error("Error in getModelsWithParams:", error);
            throw error;
        }
    }
    async getModelsByIds(ids) {
        const { data, error } = await supabase()
            .from("ChargingStationModels")
            .select("*")
            .in("id", ids)
            .eq("isDeleted", false);
        if (error) {
            throw error;
        }
        return data.map(ChargingStationModelMapper.toDomain);
    }
    async createModel(modelData) {
        try {
            const currentUserId = getRootStore().authStore.user?.id;
            const { data, error } = await supabase()
                .from("ChargingStationModels")
                .insert([
                {
                    ...ChargingStationModelMapper.toCreateDto(modelData),
                    idCreatedBy: currentUserId,
                },
            ])
                .select()
                .single();
            if (error)
                throw error;
            return ChargingStationModelMapper.toDomain(data);
        }
        catch (error) {
            console.error("Error creating charging station model:", error);
            throw error;
        }
    }
    async updateModel(id, modelData) {
        try {
            const currentUserId = getRootStore().authStore.user?.id;
            const { data, error } = await supabase()
                .from("ChargingStationModels")
                .update({
                ...ChargingStationModelMapper.toCreateDto(modelData),
                idUpdatedBy: currentUserId,
            })
                .eq("id", id)
                .select()
                .single();
            if (error)
                throw error;
            return ChargingStationModelMapper.toDomain(data);
        }
        catch (error) {
            console.error("Error updating charging station model:", error);
            throw error;
        }
    }
    async deleteModel(id) {
        try {
            const currentUserId = getRootStore().authStore.user?.id;
            const { error } = await supabase()
                .from("ChargingStationModels")
                .update({
                isDeleted: true,
                idUpdatedBy: currentUserId,
            })
                .eq("id", id);
            if (error)
                throw error;
        }
        catch (error) {
            console.error("Error deleting charging station model:", error);
            throw error;
        }
    }
}
// Export singleton instance
export const chargingStationModelService = new ChargingStationModelService();
